import services from "../services";
import * as types from "./mutation-type";

export const setQuiz = ({ commit }, payload) => {
    commit(types.SET_QUIZ, payload);
};

export const ActionGetByQuizId = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.getByQuizId(payload);
        if (data.error === false) {
            resolve(data);
        }
        reject(data);
    });
};

export const ActionGetQuiz = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.get(payload);
        if (data.error === false) {
            resolve(data);
        }
        reject(data);
    });
};

export const ActionCreateQuiz = async ({ _ }, payload) => {
    return new Promise(async (resolve, reject) => {
        const { data } = await services.create(payload);
        if (data.error === false) {
            resolve(data);
        }
        reject(data);
    });
};
